export default {
  loading: state => state.loading,
  saving: state => state.saving
}
